import { render, staticRenderFns } from "./AIBriefGenerator.vue?vue&type=template&id=148f41fb&scoped=true"
import script from "./AIBriefGenerator.vue?vue&type=script&lang=js"
export * from "./AIBriefGenerator.vue?vue&type=script&lang=js"
import style0 from "./AIBriefGenerator.vue?vue&type=style&index=0&id=148f41fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f41fb",
  null
  
)

export default component.exports